import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBell: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconBell"><Path d="M12 2C7.79219 2 4.26146 5.17264 3.8132 9.35647L3.08234 16.6755C3.03825 17.117 3.38495 17.5 3.82863 17.5H20.1714C20.615 17.5 20.9617 17.117 20.9177 16.6755L20.1867 9.35648C19.7385 5.17264 16.2078 2 12 2Z" fill="currentColor"/><Path d="M16.5839 19H7.41601C8.18757 20.7659 9.94965 22 12 22C14.0503 22 15.8124 20.7659 16.5839 19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBell;
